import React, { Fragment, FunctionComponent, useEffect, useRef, useState } from 'react';
import './login.scss'
import { useHistory } from 'react-router-dom';

import TextInput from '../../components/textInput/textInput';
import Footer from '../../components/footer/footer';
import AxisButton from '../../components/button/button';
import Text from '../../components/typography/typgraphy';
import {
  LOGIN_INPUT_PLACEHOLDER,
  PASSWORD_INPUT_PLACEHOLDER,
  WELCOME_MESSAGE,
  FORGOT_PASSWORD,
  LOGIN,
  REGISTER,
  ENABLE_LOGIN_ID,
  LOGIN_TXN_NOT_FOUND,
  LOGIN_USER_NOT_FOUND,
  LOGIN_TXN_LOCKED,
  LOGIN_CUSTOMER_NOT_FOUND,
  LOGIN_USER_DISABLED,
  NEW_ACCOUNT_DISABLED
} from '../../constants/messages';
import { ClearIcon } from '../../assets/svgs/svg';
import {
  APPLICATION_LOADED,
  APP_URLS,
  ARGO_CUSTOMER_NOT_FOUND,
  ARGO_INVALID_CREDENTIALS,
  ARGO_TXN_LOCKED,
  ARGO_TXN_NOT_FOUND,
  ARGO_USER_DISABLED,
  ARGO_USER_NOT_FOUND,
  ENABLE_LOGIN_ID_ENDPOINT,
  ENTER_KEYCODE,
  FORGOT_PASSWORD_ENDPOINT,
  NEW_ACCOUNT,
  REGISTER_ENDPOINT,
  TXN_TIMED_OUT
} from '../../constants/constants';
import Loader from '../../components/loader/loader';
import { IErrorResponseType } from '../../constants/commonTypes';
import { ENABLE_LOGINID_GA, FORGOT_PASSWORD_GA, LOGIN_PAGE_LOAD_PARAM, LOGIN_PAGE_LOAD_VPV, pushDataLayer, REGISTER_USER_GA, LOGIN_CLICKED_GA, VIRTUAL_KEYBOARD_GA, MPIN_NEXT_GA } from '../../constants/gaConstants';
import { setStorage, crypt , gaEncrypt} from '../../constants/utils';
import VirtualKeyboard from "../../components/virtualKeyboard/virtualKeyboard"
import keyboardIcon from '../../assets/images/keyboardIcon.svg'
import { loadCaptchaEnginge, LoadCanvasTemplate, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';
import { AuthState } from '../../core/reducers/authReducer';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { MOBILE_REGEX } from '../../constants/constants';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import { mpinLoginApi } from '../../core/actionCreators/mpinActionCreators';
import { useDispatch, useSelector } from "react-redux";
import profileIcon from "../../assets/images/login-icon.svg";
import otpIcon from "../../assets/images/otp-icon.svg";
import rateIcon from "../../assets/images/rate-icon.svg";
import tncIcon from "../../assets/images/tnc-icon.svg";
import txnIcon from "../../assets/images/txn-icon.svg";

interface ILoginProps {
  authError: IErrorResponseType | null;
  authResponse: boolean | undefined;
  isLoading: boolean;
  onLogin(request: object): void;
  transactionId: string;
  isAuthenticated: boolean;
  partnerData: AuthState;
}

function TabPanel(props) {	
  const { children, value, index, ...other } = props;	
  return (	
    <div	
      role="tabpanel"	
      hidden={value !== index}	
      id={`simple-tabpanel-${index}`}	
      aria-labelledby={`simple-tab-${index}`}	
      {...other}	
    >	
      {value === index && (	
        <Box sx={{ p: 3 }}>	
          <Typography>{children}</Typography>	
        </Box>	
      )}	
    </div>	
  );	
}	
TabPanel.propTypes = {	
  children: PropTypes.node,	
  index: PropTypes.number.isRequired,	
  value: PropTypes.number.isRequired,	
};	
function a11yProps(index) {	
  return {	
    id: `simple-tab-${index}`,	
    'aria-controls': `simple-tabpanel-${index}`,	
  };	
}

const Login: FunctionComponent<ILoginProps> = (props) => {
  const dispatch = useDispatch();
  const { onLogin, authResponse, authError, isAuthenticated, transactionId, isLoading, partnerData } = props;
  const [loginId, setLoginId] = useState('')
  const [password, setPassword] = useState('')
  const [loginError, setLoginError] = useState(false)
  const [loginErrorMessage, setLoginErrorMessage] = useState("")
  const loginIdRef = useRef<HTMLInputElement>(null)
  const passwordRef = useRef<HTMLInputElement>(null)
  const captchaRef = useRef<HTMLInputElement>(null)
  const [disableLogin, setDisableLogin] = useState(true)
  const [captcha, setCaptcha] = useState('')
  const [captchaErr, setCaptchaErr] = useState(false)
  const history = useHistory();
  const [virtualKey, setVirtualKey] = useState(false)
  const [disablePassword, setDisablePassword] = useState(false)
  const [value, setValue] = useState(0);	
  const [showMob , setShowMob] = useState(false);	
  const [mobile , setMobile] = useState('');	
  const mobileRef = useRef<HTMLInputElement>(null)	
  const [mobileErr , setMobileErr] = useState(false);	
  const [disableNext , setDisableNext] = useState(true);	
  const [mpinErr, setMpinErr] = useState(false);
  const auth = useSelector(state => state.auth)
  const mpinLogin = useSelector(state => state.mpin)

  const MPIN_URL = process.env.REACT_APP_MPIN_REDIRECT_ENDPOINT 

  // GA on page load
  useEffect(() => {
    pushDataLayer(LOGIN_PAGE_LOAD_PARAM(transactionId))
    pushDataLayer(LOGIN_PAGE_LOAD_VPV(transactionId))
  }, [])
  //useeffects and functions for login form---	
  //check loginid, pwd, captcha vals
  useEffect(() => {
    if (loginId !== '' && password !== '' && captcha !== '' && captcha.length === 6) {
      setDisableLogin(false)
    } else {
      setDisableLogin(true)
    }
  }, [loginId, password, captcha])
  //redirect to txn detail page
  useEffect(() => {
    if (isAuthenticated && authError !== undefined && !authError) {
      setStorage(APPLICATION_LOADED, true)
      history.push(`${APP_URLS.TRANSACTION_DETAILS.replace(":txnId", transactionId)}`);
    }
  }, [isAuthenticated, transactionId, history, partnerData, authError])


  // TODO: Redirect to Error Page if recieved error code in login API
  useEffect(() => {
    if (authResponse !== undefined && authResponse) {
      // Success navigation
      setLoginError(false)
      history.push(`${APP_URLS.TRANSACTION_DETAILS.replace(":txnId", transactionId)}`);
    }
    else if (authError !== undefined && authError) {
      switch (authError.code) {
        case ARGO_TXN_NOT_FOUND:
          setLoginErrorMessage(LOGIN_TXN_NOT_FOUND)
          break;
        case TXN_TIMED_OUT:
          setLoginErrorMessage(authError.error_message)
          break;
        case ARGO_INVALID_CREDENTIALS:
          setLoginErrorMessage(authError.error_message)
          break;
        case TXN_TIMED_OUT:
          setLoginErrorMessage(authError.error_message)
          break;
        case ARGO_USER_NOT_FOUND:
          setLoginErrorMessage(LOGIN_USER_NOT_FOUND)
          break;
        case ARGO_USER_DISABLED:
          setLoginErrorMessage(LOGIN_USER_DISABLED)
          break;
        case ARGO_CUSTOMER_NOT_FOUND:
          setLoginErrorMessage(LOGIN_CUSTOMER_NOT_FOUND)
          break;
        case ARGO_TXN_LOCKED:
          setLoginErrorMessage(LOGIN_TXN_LOCKED)
          break;
        case NEW_ACCOUNT:
          setLoginErrorMessage(NEW_ACCOUNT_DISABLED)
          break;
      }
      setLoginError(true)
      setCaptcha('')
    }
    else if (auth.ibError){
      history.push({
          pathname: `${APP_URLS.ERROR_LOGIN}`
        });
    }
  }, [authResponse, authError, history, transactionId, auth.ibError])

  //Generate captcha
  useEffect(()=>{	
    if(loginError || value === 1)	
      loadCaptchaEnginge(6); 	
  },[loginError, value])	
  useEffect(()=>{	
    if(mobileErr || value === 0)	
      loadCaptchaEnginge(6); 	
  },[mobileErr, value])

  const handleForgotPassword = () => {
    pushDataLayer(FORGOT_PASSWORD_GA(crypt(loginId, transactionId), transactionId))
  }

  const handleRegisterUser = () => {
    pushDataLayer(REGISTER_USER_GA(crypt(loginId, transactionId), transactionId))
  }

  const handleEnableLoginID = () => {
    pushDataLayer(ENABLE_LOGINID_GA(crypt(loginId, transactionId), transactionId))
  }

  const handleLoginClear = () => {
    setLoginId('')
  }

  const handlePasswordClear = () => {
    setPassword('')
    setDisablePassword(false)
  }

  const handleLoginIdChange = (e: any) => {
    setLoginErrorMessage('');
    setLoginId(e.target.value);
  }
  const handlePasswordChange = (e: any) => {
    setLoginErrorMessage('');
    setPassword(e.target.value);
  }
  const handleCaptchaChange = (e: any) => {
    setLoginErrorMessage('');
    setCaptchaErr(false)
    setCaptcha(e.target.value);
  }
  const handleLogin = async () => {
    pushDataLayer(LOGIN_CLICKED_GA(crypt(loginId, transactionId), transactionId))
    if (validateCaptcha(captcha)==true){
      setCaptchaErr(false)
      // loadCaptchaEnginge(6); 
      // document.getElementById('user_captcha_input').value = "";
      if (loginId === '' && loginIdRef.current) {
        loginIdRef.current.focus()
      }
      else if (password === '' && passwordRef.current) {
        passwordRef.current.focus()
      }
      else if (captcha === '' && captchaRef.current) {
        captchaRef.current.focus()
      }

      if (loginId !== '' && password !== '') {
        let request = {
          userId: crypt(loginId,props.transactionId),
          password: crypt(password,props.transactionId),
          txnId: props.transactionId
        }
        await onLogin(request);
        setLoginId('')
        setPassword('')
        setDisablePassword(false)
      }
    }
    else {
      setCaptchaErr(true)
      setDisableLogin(true)
      // document.getElementById('user_captcha_input').value = "";
      setLoginId('')
      setPassword('')
      setCaptcha('')
      setDisablePassword(false)
    }
    
  }

  const handleVirtualKeyboard = () =>{
    pushDataLayer(VIRTUAL_KEYBOARD_GA(crypt(loginId, transactionId), transactionId))
    setVirtualKey(!virtualKey)
    setPassword('')
  }
  const handleVirtualPassword = (password:any) => {
    if(password){
      setDisablePassword(true)
    }
    else{
      setDisablePassword(false)
    }
    setPassword(password)
  }

  const handleClose = (close:any) => {
    setVirtualKey(close)
    if(disablePassword){
      setDisablePassword(false)
    }
  }

   //useeffect and functions for tab structure--	
   const handleTabChange = (event, newValue) => {	
    setValue(newValue);	
    setLoginId('')	
    setPassword('')	
    setMobile('')	
    setCaptcha('')	
    setLoginError(false)	
    setCaptchaErr(false)	
    setMobileErr(false)	
    setShowMob(false)	
  };	
  	
  //useEffect and functions for mpin login--	
  const clickedMobVal = (status:boolean) => {	
    setShowMob(status)	
  }	
  	
  const handleMobileChange = (e: any) => {	
    if (e.nativeEvent.data >= 0){	
        setMobile(e.target.value )	
        setMobileErr(false)	
        setCaptchaErr(false)	
        // setDisableNext(false)	
        if(e.target.value.length === 10){	
            if(e.target.value.length>0 && (e.target.value.length!=10 || !MOBILE_REGEX.test(e.target.value))){	
              setMobileErr(true)	
            }	
            else {	
              setMobileErr(false)	
            }	
        }	
    }	
  }	
  const mobBlur = () => {	
    if(mobile.length <= 0){	
        setShowMob(false)	
    }	
    if(mobile.length>0 && (mobile.length!=10 || !MOBILE_REGEX.test(mobile))){	
      setMobileErr(true)	
    }	
    else {	
      setMobileErr(false)	
    }	
  }	
  //call mpin API	
  const handleNext = () => {	
    pushDataLayer(MPIN_NEXT_GA(transactionId))
    if (validateCaptcha(captcha)==true){	
      setCaptchaErr(false)	
      const request = {	
        mobNo : '91' + mobile,	
        txnId : transactionId	
      }	
      dispatch(mpinLoginApi(request))	
    }	
    else {	
      setCaptchaErr(true)	
      setDisableNext(true)	
      setMobile('')	
      setCaptcha('')	
      setShowMob(false)	
    }	
  }	
  	
  useEffect(()=>{	
    if(mpinLogin.mpin_login_code == 6000){	
      // setUrl('https://mobiletp.axisbank.co.in:7443/MpinAuth/sso-auth/validate?data='+mpinLogin.mpin_login_payload)	
      let f = document.createElement("form");	
      f.action = MPIN_URL;	
      f.method = "POST";	
      let i = document.createElement("input");	
      i.type = "hidden";	
      i.name='data';
      i.value = mpinLogin.mpin_login_payload;
      f.appendChild(i);	
      document.body.appendChild(f);	
      f.submit();	
    }	
    if(mpinLogin.mpin_login_code == 7000 || mpinLogin.mpin_login_code == 7002 || mpinLogin.mpin_login_code == 7003 || mpinLogin.mpin_login_code == 7009 || mpinLogin.mpin_login_code == 7010 || mpinLogin.mpin_login_code == 7011){	
      setMpinErr(true)		
    }	
  },[mpinLogin.mpin_login_code])	
  	
  //enable disable next	
  useEffect(() => {	
    if (mobile !== '' && MOBILE_REGEX.test(mobile) && captcha.length == 6 && captchaErr === false ) {	
            setDisableNext(false)     	
    } 	
    else {	
      setDisableNext(true)	
    }	
  }, [mobile, captcha, captchaErr])

  return (
    <Fragment>
      {isLoading && <Loader />}
      <div className='etb-login-page'>
        <div className='etb-login-page__login-div'>
          <div className="etb-login-form__head">
            <Text className="etb-login-form__head__text" fontSize={19} fontWeight={600}>{WELCOME_MESSAGE}</Text>
          </div>
          <Box sx={{ width: '100%' }} className = 'etb-login-form'>
            <Box className = 'etb-login-form__tab-container'>
              <Tabs value={value} onChange={handleTabChange} aria-label="basic tabs structure" className = 'etb-login-form__tab-container__head'>
                <Tab className = 'etb-login-form__tab-container__head__tab' label="MPIN" {...a11yProps(0)} />
                <Tab className = 'etb-login-form__tab-container__head__tab' label="Login ID/ Customer ID" {...a11yProps(1)} />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              <div className="login-container">
                <div className="login-wrapper">
                  <div className="login-content-wrapper">
                    {showMob===true? 
                      <div className={`mpin-registered-mobile form-field  `}>
                        <TextField id="standard-required" label="Registered Mobile No." variant="standard" className= {`mpin-form-input`}
                          onChange={(e) => handleMobileChange(e)}
                          value={mobile}
                          autoComplete = 'off'
                          // autoFocus = {true}
                          inputProps={{
                              maxLength : 10,
                              onBlur: () => mobBlur(),
                          }}
                          InputProps={{
                              startAdornment: <InputAdornment position="start" className='mobile-code'>+91</InputAdornment>,                    
                          }} 
                        />
                        {mobileErr? 
                          <div className="error-text">
                              Invalid Mobile Number
                          </div> 
                        :''}
                      </div> :
                      <div className='mpin-registered-mobile form-field'>
                          <TextField id="standard-required" label="Registered Mobile No." variant="standard" className="mpin-form-input mobile-basic" value = ''
                          onFocus={() => clickedMobVal(true)}
                          />
                      </div>
                    }
                    {mpinErr
                      ? <Text className={"error-text"}>{mpinLogin.mpin_error_message}</Text>
                      : null}
                  </div>
                  <div className='login-captcha-block'>
                    <div className='login-captcha-block__captcha-code'>
                      <LoadCanvasTemplate />
                      {/* <div className='login-captcha-block__captcha-code__helperText'>Type image text</div> */}
                    </div>
                    <div className='login-captcha-block__captcha-val'>
                      <TextInput
                        inputRef={captchaRef}
                        customStyle={"input-text"}
                        value={captcha}
                        type="password"
                        autocomplete = 'off'
                        placeholder='Enter above Captcha'
                        inputProps={{ maxLength: 6 }}
                        handleOnChange={(e) => handleCaptchaChange(e)}
                        onPaste={(e:any)=>{
                          e.preventDefault()
                          return false;
                        }} 
                        onCopy={(e:any)=>{
                          e.preventDefault()
                          return false;
                        }}
                        onKeyPress={(data: any) => {
                          if (data.charCode === ENTER_KEYCODE) {
                            handleNext()
                          }
                        }}
                      />
                      <Text className={"captcha-input-helper"}>(Captcha code is case sensitive)</Text>
                    </div>
                    {captchaErr?<Text className={"captcha-input-error"}>Invalid captcha entered</Text>:<Text className={"captcha-input-error empty"}>Invalid captcha entered</Text>}
                  </div>
                  <div className="submit-container">
                      <AxisButton onClick={handleNext} disabled={disableNext} disableElevation fullWidth={true} customStyle={"submit-btn-primary"} variant="contained">
                          <Text className={"submit-btn-text"}>Next</Text>
                      </AxisButton>
                  </div>
                  {/* <form action = {url} method="post" name = "mpinForm"><button type="submit" value="Submit" className="submit-mpin-redirect">Submit</button></form> */}
                </div>
              </div>
            </TabPanel>
            <TabPanel value={value} index={1} >
              <div className="login-container">
                <div className="login-wrapper">
                  {/* <div className="login-heading-wrapper">
                    <Text className="login-heading-text" fontSize={19} fontWeight={600}>{WELCOME_MESSAGE}</Text>
                  </div> */}
                  <div className="login-content-wrapper">
                    <TextInput
                      inputRef={loginIdRef}
                      customStyle={"input-text"}
                      value={loginId}
                      label={LOGIN_INPUT_PLACEHOLDER}
                      type="text"
                      suffix={true}
                      suffixOnClick={() => handleLoginClear()}
                      suffixElement={<ClearIcon height={25} width={25} />}
                      handleOnChange={(e) => handleLoginIdChange(e)}
                      onKeyPress={(data: any) => {
                        if (data.charCode === ENTER_KEYCODE) {
                          handleLogin()
                        }
                      }}
                    />
                    {loginError && authError?.code === ARGO_USER_DISABLED
                      ? <Text className={"error-text"}>{loginErrorMessage}</Text>
                      : null}
                    <TextInput
                      inputRef={passwordRef}
                      customStyle={"input-text"}
                      value={password}
                      label={PASSWORD_INPUT_PLACEHOLDER}
                      disabled={virtualKey || disablePassword}
                      type="password"
                      suffix={true}
                      suffixOnClick={() => handlePasswordClear()}
                      suffixElement={<ClearIcon height={25} width={25} />}
                      handleOnChange={(e) => handlePasswordChange(e)}
                      onKeyPress={(data: any) => {
                        if (data.charCode === ENTER_KEYCODE) {
                          handleLogin()
                        }
                      }}
                    />
                  </div>

                  <div className='virtualKeyboardContainer'> <div className="virtualText" onClick={handleVirtualKeyboard}><img src={keyboardIcon} />Use Virtual Keyboard</div>
                  {virtualKey ? <VirtualKeyboard virtualPassword={handleVirtualPassword} closeKeyboard={handleClose}/> : null}
                  </div>

                  {loginError && authError?.code !== ARGO_USER_DISABLED
                    ? <Text className={"error-text"}>{loginErrorMessage}</Text>
                    : null}
                  <div className="hyperlink-btn-wrapper">
                    <AxisButton onClick={handleForgotPassword} href={FORGOT_PASSWORD_ENDPOINT} target="_blank" customStyle={"hyperlink-btn"}>
                      <Text className={"hyperlink-btn-text"}>{FORGOT_PASSWORD}</Text>
                    </AxisButton>
                  </div>

                  <div className='login-captcha-block'>
                    <div className='login-captcha-block__captcha-code'>
                      <LoadCanvasTemplate />
                      {/* <div className='login-captcha-block__captcha-code__helperText'>Type image text</div> */}
                    </div>
                    <div className='login-captcha-block__captcha-val'>
                      <TextInput
                        inputRef={captchaRef}
                        customStyle={"input-text"}
                        value={captcha}
                        type="password"
                        autocomplete = 'off'
                        placeholder='Enter above Captcha'
                        inputProps={{ maxLength: 6 }}
                        handleOnChange={(e) => handleCaptchaChange(e)}
                        onPaste={(e:any)=>{
                          e.preventDefault()
                          return false;
                        }} 
                        onCopy={(e:any)=>{
                          e.preventDefault()
                          return false;
                        }}
                        onKeyPress={(data: any) => {
                          if (data.charCode === ENTER_KEYCODE) {
                            handleLogin()
                          }
                        }}
                      />
                      <Text className={"captcha-input-helper"}>(Captcha code is case sensitive)</Text>
                    </div>
                    {captchaErr?<Text className={"captcha-input-error"}>Invalid captcha entered</Text>:<Text className={"captcha-input-error empty"}>Invalid captcha entered</Text>}
                  </div>

                  <div className="submit-container">
                    <AxisButton onClick={handleLogin} disabled={disableLogin} disableElevation fullWidth={true} customStyle={"submit-btn-primary"} variant="contained">
                      <Text className={"submit-btn-text"}>{LOGIN}</Text>
                    </AxisButton>
                    <AxisButton onClick={handleRegisterUser} href={REGISTER_ENDPOINT} target="_blank" fullWidth={true} customStyle={"submit-btn-secondary"} variant="outlined">
                      <Text className={"submit-btn-text"}>{REGISTER}</Text>
                    </AxisButton>
                    <AxisButton onClick={handleEnableLoginID} href={ENABLE_LOGIN_ID_ENDPOINT} target="_blank" customStyle={"hyperlink-btn"}>
                      <Text className={"hyperlink-btn-text"}>{ENABLE_LOGIN_ID}</Text>
                    </AxisButton>
                  </div>
                </div>
              </div>
            </TabPanel>
          </Box>
        </div>
        {/* <Divider orientation="vertical" className='divider-vertical'/> */}
        <div className='etb-login-page__instruction-div'>
          <div className='etb-login-page__instruction-div__head'>
            Remit Money In 5 Easy Steps
          </div>
          <div className='etb-login-page__instruction-div__content'>
            <div className='etb-login-page__instruction-div__content__step'><span className='login-step'><img src={profileIcon}/></span> Login to help us identify you</div>
            <div className='etb-login-page__instruction-div__content__step'><span className='login-step'><img src={txnIcon}/></span> Review transaction details</div>
            <div className='etb-login-page__instruction-div__content__step'><span className='login-step'><img src={rateIcon}/></span> Know exchange rate & charges</div>
            <div className='etb-login-page__instruction-div__content__step'><span className='login-step'><img src={tncIcon}/></span> Read through TnC applied</div>
            <div className='etb-login-page__instruction-div__content__step'><span className='login-step'><img src={otpIcon}/></span> Validate OTP</div>
          </div>
          </div>
      </div>
      <Footer />
    </Fragment>
  )
}

export default Login;
